import React from 'react';
import { Link } from "react-router-dom";
import DriverModal from '../modal/DriverModal'
import { db } from '../firebase';
import { MyContext } from '../context';
import VehicleModal from '../modal/VehicleModal';
import { Content } from '../components';
export default class Vechile extends React.Component {
  constructor(props) {
    super(props);
    this.detailModal = React.createRef();
  }
  state = {
    show: false
  }
  showModal(modal, key, amount) {
    console.log("TEst")
    modal.current.setState({
      show: true,
      key,
      amount
    });
    this.setState({
      show: true
    })
  }
  render() {
    return <Content title="Vehicle Types" state={this} />
  }
  subMenu() {
    return (
      <li className="m-nav__item">
        <a className="btn m-nav__link">
          <span className="m-nav__link-text">Vechile Types</span>
        </a>
      </li>
    )
  }
  content() {
    return (<MyContext.Consumer>
      {state => {
        const fairs = (state && state.config && state.config.fairs) ? state.config.fairs : {};
        return (
          <div>
            <table id="example" className="table table-striped table-bordered" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Vechile Type</th>
                  <th>Price Per Mile</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(fairs).map((key) => {
                  if (this.props.search == "" || key.toLowerCase().includes(this.props.search.toLowerCase().trim())) {
                    return (
                      <tr key={key}>
                        <td>{key}</td>
                        <td>$ {fairs[key]}</td>
                        <td>
                          <div className="btn-group align-items-center">
                            <a className="text-muted btn" onClick={e => { this.showModal(this.detailModal, key, fairs[key]) }} >
                              <i className="la la-pencil-square-o"></i>
                            </a>
                            {/* <Link className="text-danger" to={key}>
                                  <i className="la la-trash-o"></i>
                                </Link> */}
                          </div>
                        </td>
                      </tr>
                    )
                  }
                })}
              </tbody>
            </table>
            <VehicleModal ref={this.detailModal} show={this.state.show} hide={e => { this.setState({ show: false }) }} />
          </div>
        )
      }}
    </MyContext.Consumer>)

  }
}


// WEBPACK FOOTER //
// ./src/include/Vehicle.js